module.exports = __webpack_public_path__ + "img/Stewardship.8f55d513.gif";